export default "__VITE_ASSET__lcKrRSsB__"